import React from 'react';
import { Calendar, Users, MapPin, MessageCircle } from 'lucide-react';
import usePageTitle from '../hooks/usePageTitle';
import '../css/About.css';
import { Link } from 'react-router-dom';

const About = () => {
  usePageTitle('À propos');

  const teamMembers = [
    {
      name: "Marie Dubois",
      role: "Fondatrice",
      image: "https://placehold.co/200x200",
      description: "Passionnée de gastronomie et de culture locale"
    },
    {
      name: "Thomas Laurent",
      role: "Responsable des partenariats",
      image: "https://placehold.co/200x200",
      description: "Expert en relations commerciales"
    },
    {
      name: "Sophie Martin",
      role: "Responsable contenu",
      image: "https://placehold.co/200x200",
      description: "Journaliste et critique gastronomique"
    }
  ];

  const milestones = [
    {
      year: "2022",
      title: "Naissance de l'idée",
      description: "Après des années à explorer la Guadeloupe, l'idée de Ti'Spot 971 est née"
    },
    {
      year: "2023",
      title: "Lancement de la plateforme",
      description: "Première version de Ti'Spot 971 avec 50 établissements partenaires"
    },
    {
      year: "2024",
      title: "Développement",
      description: "Extension à toute la Guadeloupe et plus de 200 établissements référencés"
    },
    {
      year: "2025",
      title: "Aujourd'hui",
      description: "Une communauté grandissante et des partenaires de qualité"
    }
  ];

  return (
    <div className="about-page">
      {/* Hero Section */}
      <div className="about-hero">
        <div className="container">
          <h1>Notre Histoire</h1>
          <p className="subtitle">
            Découvrez comment Ti'Spot 971 est devenu votre guide de confiance en Guadeloupe
          </p>
        </div>
      </div>

      {/* Mission Section */}
      <section className="mission-section">
        <div className="container">
          <div className="content-grid">
            <div className="text-content">
              <h2>Notre Mission</h2>
              <p>
                Ti'Spot 971 est né d'une passion profonde pour la Guadeloupe et d'une volonté de 
                partager ses trésors cachés. Notre mission est simple : connecter les visiteurs 
                et les locaux avec les meilleurs établissements de l'île.
              </p>
              <p>
                Nous croyons en l'authenticité des expériences locales et en la richesse de 
                notre culture guadeloupéenne. Chaque restaurant, chaque plage, chaque lieu 
                culturel raconte une histoire unique que nous voulons partager avec vous.
              </p>
            </div>
            <div className="stats-grid">
              <div className="stat-card">
                <span className="number">200+</span>
                <span className="label">Établissements</span>
              </div>
              <div className="stat-card">
                <span className="number">15k+</span>
                <span className="label">Utilisateurs</span>
              </div>
              <div className="stat-card">
                <span className="number">1k+</span>
                <span className="label">Avis</span>
              </div>
              <div className="stat-card">
                <span className="number">32</span>
                <span className="label">Communes</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Timeline Section */}
      <section className="timeline-section">
        <div className="container">
          <h2>Notre Évolution</h2>
          <div className="timeline">
            {milestones.map((milestone, index) => (
              <div key={index} className="timeline-item">
                <div className="year">{milestone.year}</div>
                <div className="content">
                  <h3>{milestone.title}</h3>
                  <p>{milestone.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="team-section">
        <div className="container">
          <h2>Notre Équipe</h2>
          <div className="team-grid">
            {teamMembers.map((member, index) => (
              <div key={index} className="team-card">
                <img src={member.image} alt={member.name} />
                <h3>{member.name}</h3>
                <span className="role">{member.role}</span>
                <p>{member.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="container">
          <h2>Nos Valeurs</h2>
          <div className="values-grid">
            <div className="value-card">
              <Calendar size={32} />
              <h3>Authenticité</h3>
              <p>Des expériences vraies et des avis vérifiés pour vous guider au mieux.</p>
            </div>
            <div className="value-card">
              <Users size={32} />
              <h3>Communauté</h3>
              <p>Une plateforme créée par et pour les amoureux de la Guadeloupe.</p>
            </div>
            <div className="value-card">
              <MapPin size={32} />
              <h3>Local</h3>
              <p>Un focus sur les établissements qui font vivre notre île.</p>
            </div>
            <div className="value-card">
              <MessageCircle size={32} />
              <h3>Proximité</h3>
              <p>Une équipe à l'écoute et des partenaires engagés.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Join Us Section */}
      <section className="join-section">
        <div className="container">
          <div className="join-content">
            <h2>Rejoignez l'Aventure</h2>
            <p>
              Vous êtes propriétaire d'un établissement ? Vous souhaitez partager 
              vos découvertes ? Contactez-nous et participez à l'aventure Ti'Spot 971 !
            </p>
            <Link to="/contact" className="contact-btn">Nous Contacter</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;